import React, { useState, useEffect } from "react";
import ReactApexCharts from "react-apexcharts";
import { toast } from "react-toastify";
import config from "../config.js";
import axios from "axios";

export default function Franchandclientchart() {
  const [licensesCountfranch, setLicensesCountfranch] = useState(0);
  const [clientlicensesCount, setClientlicensesCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLicensesCounts = async () => {
      try {
        const [franchResponse, clientResponse] = await Promise.all([
          axios.get(`${config.apiBaseUrl}/admin/franchise_licenses_count`),
          axios.get(`${config.apiBaseUrl}/admin/client_licenses_count`)
        ]);

        setLicensesCountfranch(franchResponse.data.licenses_count || 0);
        setClientlicensesCount(clientResponse.data.licenses_count || 0);
      } catch (err) {
        toast.error("Error fetching licenses data");
        console.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchLicensesCounts();
  }, []);

  const totalLicenses = Number(licensesCountfranch) + Number(clientlicensesCount);

  const options = {
    series: [licensesCountfranch, clientlicensesCount],
    chart: {
      height: "100%",
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        offsetY: 0,
        startAngle: -135,
        endAngle: 135,
        hollow: {
          size: "50%",
          background: "transparent",
          borderradius: 90,
        },
        track: {
          background: "#EDEDED",
          strokeWidth: "97%",
          margin: 5,
        },
        dataLabels: {
          name: {
            show: true,
            fontSize: "18px",
            color: "#333",
            offsetY: -10,
          },
          value: {
            show: true,
            fontSize: "24px",
            fontWeight: "bold",
            offsetY: 5,
          },
        },
      },
    },
    colors: ["#FF007F", "#007BFF"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            height: 200,
          },
          dataLabels: {
            value: {
              fontSize: "10px",
            },
          },
        },
      },
    ],
  };

  return (
    <div>
      {loading ? (
        <div className="text-center">Loading data...</div>
      ) : (
        <>
          <h6 className="text-end">
            Total Licenses: <span className="text-dark">{totalLicenses}</span>
          </h6>
          <div className="d-flex chart align-items-center flex-direction-column">
            <ReactApexCharts
              options={options}
              series={options.series}
              type="radialBar"
            />
          </div>
        </>
      )}
    </div>
  );
}
